import { TableRow, TableCell, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../language/keys';

type AccountCounterProps = {
  total: number;
  tableColumnsCount: number;
};

const AccountsCounter = ({
  total,
  tableColumnsCount,
}: AccountCounterProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <TableRow>
      <TableCell
        colSpan={ tableColumnsCount }
        color="secondary"
        sx={ {
          pt: '6px',
          pl: '20px',
          pb: '6px',
          color: 'text.secondary',
        } }
      >
        <Typography variant="overline" sx={ { color: 'text.secondary' } }>
          {translate(STRING_KEYS.ACCOUNTS_TOTAL_COUNT, { count: total })}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default AccountsCounter;
